import { Swiper } from '@services';
import { N as Navigation } from './navigation-Bm_wcxKy.js';
import './create-element-if-not-defined-CdtEf1Zs.js';
import './utils-BgX2tuHA.js';

class FeaturedCollectionsAlt extends HTMLElement {
  swiperContainer = this.querySelector('.swiper');
  nextButton = this.querySelector('.swiper-button-next');
  prevButton = this.querySelector('.swiper-button-prev');
  slidesPerViewDesktop =
    this.swiperContainer.querySelectorAll('.swiper-slide').length === 3 ? 3 : 4;

  connectedCallback() {
    if (!this.swiperContainer) return;

    this.initSwiper();
  }

  /**
   * Initializes the swiper instance
   */
  initSwiper() {
    this.swiperInstance = new Swiper(this.swiperContainer, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 1,
      lazyPreloadPrevNext: 2,
      loop: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: this.slidesPerViewDesktop,
        },
      },
    });
  }
}

customElements.define('featured-collections-alt', FeaturedCollectionsAlt);
